import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  IdentificacaoAtendimento,
  Servico,
} from 'src/app/models/Servico.model';
import { ServicoService } from 'src/app/services/servico.service';

export class ServicoDefaultPage {
  ACTIVE_INDEX: number = 0;

  servico?: Servico;
  loading = false;

  dadosSolicitacao!: IdentificacaoAtendimento;

  _subscriptions: Subscription[] = [];

  constructor(
    protected servicoService: ServicoService,
    protected router: Router
  ) {}

  getServico(slug: string, onComplete?: Function): void {
    this._subscriptions.push(
      this.servicoService.getServicoBySlug(slug).subscribe({
        next: (servico) => {
          this.servico = servico;
          this.loading = false;

          if (onComplete) onComplete();
        },
        error: (error) => {
          this.router.navigate(['/servicos']);
        },
      })
    );
  }
}
